import React from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import { ReportCardComponentProps } from '../schema-types';
import { filterDOMProps } from '../utils/prop-normalizer';
import { PaletteColor } from '../../../../lib/types';

interface BalanceScaleData {
  title?: string;
  leftLabel: string;
  rightLabel: string;
  currentPosition: number; // 0-100 scale where 0 is left, 100 is right
  description?: string;
  playerName?: string;
  backgroundColor?: string;
  scaleColor?: string;
  indicatorColor?: string;
  height?: number;
}

export const BalanceScaleComponent: React.FC<ReportCardComponentProps> = ({
  data,
  baseData: _baseData,
  player,
  playerAssessment: _playerAssessment,
  reportCardLevel: _reportCardLevel,
  context: _context,
  ...props
}) => {
  const {
    title,
    leftLabel,
    rightLabel,
    currentPosition = 50,
    description,
    playerName,
    backgroundColor = '#f9f9f9',
    scaleColor = PaletteColor.GREEN.hex,
    indicatorColor = '#1b5e20',
    height = 60
  }: BalanceScaleData = data || {};

  const finalPlayerName = playerName || player?.firstName || 'Player';

  return (
    <Box mb={3} {...filterDOMProps(props)}>
      {title && (
        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', textAlign: 'center' }}>
          {title}
        </Typography>
      )}

      <Paper elevation={2} style={{ padding: 20, backgroundColor, borderRadius: 12 }}>
        {/* Scale Labels */}
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>
            {leftLabel}
          </Typography>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>
            {rightLabel}
          </Typography>
        </Box>

        {/* Scale Bar */}
        <Box position="relative" mb={2}>
          <Box
            style={{
              width: '100%',
              height: height,
              backgroundColor: scaleColor,
              borderRadius: height / 2,
              position: 'relative'
            }}
          >
            {/* Position Indicator */}
            <Box
              style={{
                position: 'absolute',
                top: '50%',
                left: `${currentPosition}%`,
                transform: 'translate(-50%, -50%)',
                width: 0,
                height: 0,
                borderLeft: '30px solid transparent',
                borderRight: '30px solid transparent',
                borderBottom: `40px solid ${indicatorColor}`,
                zIndex: 2
              }}
            />
          </Box>
        </Box>

        {/* Position Description */}
        <Typography variant="body2" style={{ textAlign: 'center', marginBottom: 16 }}>
          This placement shows where {finalPlayerName} currently sits on the balance-to-specialization scale.
        </Typography>

        {description && (
          <Typography variant="body2" style={{ fontStyle: 'italic', color: '#666' }}>
            {description}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};
